<template>
    <div 
    class="w-100 p-3 shadow bg-white border-15" 
    style="height:72px; 
        background-repeat: no-repeat;
        background-position: 55px bottom;
        background-size: inherit; display: flex; align-items: center;"
        :style="'background-image:url('+require('../../assets/img/crm_bg.svg')+')'"
        v-if="my_crm && windowWidth>1000"
    >
        <span class="span_14">
            نام پشتیبان شما:
        </span>
        &nbsp;
        <span class="crm_t">
            {{ my_crm.fullname }}
        </span>
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        <span class="span_14">
            شماره داخلی:
        </span>
        &nbsp;
        <span class="crm_t">
            {{ my_crm.tel }}
        </span>
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        <span class="span_14">
            شماره تلفن همراه:
        </span>
        &nbsp;
        <span class="crm_t">
            {{ my_crm.phone }}
        </span>
    </div>
    <div class="w-100 p-3 shadow bg-white border-15"  v-else-if="my_crm">
        <table class="w-100">
            <tr>
                <td class="font_8">نام پشتیبان شما:</td>
                <td class="font_8">شماره داخلی:</td>
                <td class="font_8">شماره داخلی:</td>
            </tr>
            <tr>
                <td class="text-center font_10"> {{ my_crm.fullname }}</td>
                <td class="text-center font_10">{{ my_crm.tel }}</td>
                <td class="text-center font_10"> {{ my_crm.phone }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
	export default {
		name: 'crm_user',
		data(){
			return {
                my_crm: null,
			}
		},
		components: {
		},
		props: [],
		computed :{
		},
		mounted(THIS=this){
            if(!THIS.$sessionStorage.get('my_crm')){
                window.$.post(window.baseurl+'dashboard/crm', {
                    token: this.$localStorage.get("user")
                    }, function(D){
                        THIS.my_crm = D.data;
                        THIS.$sessionStorage.set('my_crm', D.data);
                }, "json");
            }else{
                THIS.my_crm =THIS.$sessionStorage.get('my_crm');
            }
		},
		methods:{

		}
	}
</script>
<style scoped>
.crm_t{
    font-size: 12px !important;
    color: #676767;
}
.span_14{
    font-size: 14px;
}
.font_8{
    font-size: 14px;
    color: black;
    text-align: center;
}
.font_10{
    font-size: 12px;
    color: #676767;
}
</style>